import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Divider from '@material-ui/core/Divider';

import styles from "assets/jss/material-kit-react/components/admin/adminStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard(props) {
  const classes = useStyles();
  const { image } = props;
  return (
    <GridContainer justify="left" className={classes.box}>
      <GridItem xs={12} sm={12} md={12}>

        <div className={classes.center}>
          برای مشاهده اطلاعات پرداخت، از منوی بالا "پرداخت‌ها" را انتخاب کنید.
        </div>
      </GridItem>
    </GridContainer>
  );
}
